import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { workspacesList } from "../../../../../../../services/ticketWorkspace.service";
import { useTranslation } from "react-i18next";
import { TQuickAnswerForm } from "../QuickAnswerSchema";
import { useWatch } from "react-hook-form";

const translationPath = "page.settings.quickAnswer.";

export const TicketWorkspaceSelector = memo(() => {
  const { t } = useTranslation();

  const { control } = useFormContext<TQuickAnswerForm>();

  const [options, setOptions] = useState<ISelectType[]>([]);

  const currentShareType = useWatch({ name: "shareType", control });

  const { sendRequest } = useFetch(workspacesList);

  const fetchTicketWorkspaces = useCallback(async () => {
    const { data, success } = await sendRequest(null);
    if (data && success) {
      setOptions(data);
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchTicketWorkspaces();
  }, [fetchTicketWorkspaces]);

  if (!currentShareType || currentShareType.code !== "2") return null;

  return (
    <Grid item xs={12} md={6}>
      <AutoComplete
        name="ticketWorkspace"
        label={t(translationPath + "ticket_workspace")}
        options={options}
        getOptionLabel={(option) => option.name}
        size="small"
      />
    </Grid>
  );
});
